/** @format */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { get, set } from 'lodash';
import { bookingRequestApi } from 'src/api/booking-request-api';
import { tabs } from './ultis';

const initialState = {
  popoverBooking: {
    open: false,
    tab: tabs.requestNew.value,
    requestFocusId: null
  },
  requests: {
    isSuccess: false
  }
};

export const BookingNoticeSlice = createSlice({
  name: 'bookingNotice',
  initialState: initialState,
  reducers: {
    setBookingRequest(state, action) {
      state.requests = action.payload;
    },

    setPushRejectToBookingRequest(state, action) {
      const requestId = action.payload;
      const currentRequests = get(state, `requests.data`, []);
      // Tìm và xử lý các request dựa trên giá trị isAccepted
      const updatedRequests = currentRequests.filter((request) => request.id !== requestId); // Loại bỏ request nếu bị từ chối
      set(state, `requests.data`, updatedRequests);
    },

    setPushNewToBookingRequest(state, action) {
      const curRequest = get(state.requests, 'data', []);
      const content = action.payload;
      state.requests = { isSuccess: true, data: [content, ...curRequest] };
    },
    removePushAssignedToBookingRequest(state, action) {
      const curRequests = get(state.requests, 'data', []);
      const requestIdToRemove = action.payload;

      // Lọc bỏ request có id trùng với requestIdToRemove
      const filteredRequests = curRequests.filter((request) => request.id !== requestIdToRemove);

      state.requests = { isSuccess: true, data: filteredRequests };
    },

    setBookingRequestPopoverFocus(state, action) {
      const { requestId, ...popoverBooking } = action.payload;

      // Kết hợp mảng cũ với phần tử mới, rồi loại bỏ giá trị trùng lặp
      // const updatedNoticeRequest = Array.from(new Set([...state.popoverBooking.noticeRequest, requestId]));

      // Mở popover -> mở tab -> focus
      state.popoverBooking = {
        ...popoverBooking,
        open: true,
        requestFocusId: requestId
      };
    },

    setBookingRequestPopoverRemoveFocus(state) {
      state.popoverBooking = {
        ...state.popoverBooking,
        requestFocusId: null
      };
    },
    setOpenBookingRequestPopover(state, action) {
      state.popoverBooking = { ...state.popoverBooking, open: action.payload };
    },
    setTabBookingRequestPopover(state, action) {
      state.popoverBooking = { ...state.popoverBooking, tab: action.payload };
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(bookingRequestApi.endpoints.getBookingRequestByUser.matchFulfilled, (state, action) => {
      state.requests = {
        isSuccess: true,
        data: action.payload
      };
    });
  }
});
export const {
  setBookingRequest,
  setPushRejectToBookingRequest,
  setPushNewToBookingRequest,
  removePushAssignedToBookingRequest,

  setBookingRequestPopoverFocus,
  setBookingRequestPopoverRemoveFocus,
  setOpenBookingRequestPopover,
  setTabBookingRequestPopover
} = BookingNoticeSlice.actions;
export const selectBookingNoticeRequests = ({ bookingNotice }) => bookingNotice.requests;

export const selectBookingNoticepPopover = ({ bookingNotice }) => bookingNotice.popoverBooking;
export const selectBookingNoticepPopoverOpen = ({ bookingNotice }) => bookingNotice.popoverBooking.open;
export const selectBookingNoticepPopoverTab = ({ bookingNotice }) => bookingNotice.popoverBooking.tab;
export const selectBookingNoticepPopoverFocus = ({ bookingNotice }) => bookingNotice.popoverBooking.requestFocusId;

export const selectBookingNoticepPopoverCheckFocus = createSelector(
  [selectBookingNoticepPopoverFocus, (_state, requestId) => requestId],
  (requestFocusId, requestId) => requestFocusId === requestId
);
export default BookingNoticeSlice.reducer;
